const PROPERTY_SOURCE_USER_ID = /^userId:\d+$/;
const PROPERTY_SOURCE_SMART_PROPERTY_RESULT_ID = /(smartPropertyResultId:)([0-9]+)/;
const PROPERTY_SOURCE_SMART_DATA_CAPTURE_SUGGESTION_ID = /smartDataCaptureAiSuggestion:(\d+-\d+):(\d+):(\d+)/;

/**
 * @return {boolean} Whether the given value represents a property source userId.
 * Property source values may use the format `userId:123` to indicate that the
 * source of a property change was a HubSpot user.
 */
export function isPropertySourceUserId(source) {
  return !!(source && PROPERTY_SOURCE_USER_ID.test(source));
}

/**
 * @return {number} Parsed user id (`123`) from a `userId:123` property source user id value.
 */
export function parsePropertySourceUserId(source) {
  if (source && PROPERTY_SOURCE_USER_ID.test(source)) {
    const id = source.split('userId:')[1];
    return parseInt(id, 10);
  }
  return undefined;
}

/**
 * @return {number | undefined} Parsed smart property result id (`123`) from a `smartPropertyResultId:123` or `smartPropertyResultId:123;enrollmentId:1;actionExecutionIndex:4` property source property result id value.
 */
export function parsePropertySourceIdSmartPropertyResultId(sourceId) {
  if (!sourceId) {
    return undefined;
  }
  const match = sourceId.match(PROPERTY_SOURCE_SMART_PROPERTY_RESULT_ID);
  if (match) {
    const parsedId = parseInt(match[2], 10);
    return Number.isNaN(parsedId) ? undefined : parsedId;
  }
  return undefined;
}
export function parsePropertySourceSmartDataCaptureSuggestionId(sourceId) {
  const match = sourceId === null || sourceId === void 0 ? void 0 : sourceId.match(PROPERTY_SOURCE_SMART_DATA_CAPTURE_SUGGESTION_ID);
  if (!match) {
    return null;
  }
  const [, objectTypeId, objectId, suggestionId] = match;
  const objectIdNumber = parseInt(objectId, 10);
  const suggestionIdNumber = parseInt(suggestionId, 10);
  if (Number.isNaN(objectIdNumber) || Number.isNaN(suggestionIdNumber)) {
    return null;
  }
  return {
    objectTypeId,
    objectId: objectIdNumber,
    suggestionId: suggestionIdNumber
  };
}